import React from "react";

export default function Logo({
  business,
  height = "h-auto",
  width = "w-full",
  variant = "dark",
  slim = false,
  containerCls = "",
}) {

  let filename = `logo-${business}.svg`;
  if (business === "kerakoll") {
    if (slim)
      filename = "logo-kerakoll-tight.svg";
    else if (variant === "dark")
      filename = "logo-kerakoll.svg";
    else
      filename = "logo-kerakoll_white.svg";
  }

  return (
    <div className={`flex-shrink-0 flex items-center ${containerCls}`}>
      <img
        className={`${height} ${width} max-h-24`}
        src={`${process.env.PUBLIC_URL}/${filename}`}
        alt={`${business} logo`}
        type="image/svg+xml"
      />
    </div>
  );
}
